export default __webpack_public_path__ + "static/media/about-S.c5b4b1b7.jpg";